import { Box, Stack, Tooltip } from '@mui/material';
import { useMemo } from 'react';

import useStyles from './SegmentedProgressBar.styles';
import type { SegmentedProgressBarProps } from './SegmentedProgressBar.types';
import SegmentedProgressBarLegend from './SegmentedProgressBarLegend/SegmentedProgressBarLegend';

const SegmentedProgressBar = ({
  data
}: {
  data: SegmentedProgressBarProps[];
}) => {
  const { classes } = useStyles();

  const totalWidth = useMemo(() => {
    if (data) {
      let count = 0;
      data.forEach((item: SegmentedProgressBarProps) => {
        count += item.data[0];
      });
      return count;
    }
    return 0;
  }, [data]);

  return (
    <Stack sx={{ height: '100%', justifyContent: 'center' }} spacing={1.5}>
      <Box className={classes.progressBarBox}>
        {data.map((item: SegmentedProgressBarProps) => {
          return (
            <Tooltip key={item.name} title={`${item.name} - ${item.data[0]}`}>
              <Box
                sx={{
                  width: `${(item.data[0] / totalWidth) * 100}%`,
                  backgroundColor: item.color
                }}
              />
            </Tooltip>
          );
        })}
      </Box>
      <SegmentedProgressBarLegend data={data} />
    </Stack>
  );
};

export default SegmentedProgressBar;
